import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { PageContentComponent } from 'src/app/shared/components/page-content/page-content.component';
import { RouteToPageDataService } from 'src/app/shared/services/route-to-page-data.service';

export const routes: Routes = [
  {
    path: '',
    component: PageContentComponent,
    resolve: { data: (route: ActivatedRouteSnapshot) => inject(RouteToPageDataService).getPageData(route) },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: '**',
    component: PageContentComponent,
    resolve: { data: (route: ActivatedRouteSnapshot) => inject(RouteToPageDataService).getPageData(route) },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
];
